<template>
    <el-dialog  
    :title="$t('products.dialog_title')" :visible.sync="showPopup" class="my-dialog-class">
        
        <el-form :label-position="'top'" :inline="false" :rules="rules" label-width="100%"  :model='selectedObject'  ref='my-form' @submit.prevent="save" v-loading="loading">
             <el-row :gutter="15">

                 <el-col :span="12">
                    <el-form-item :label="$t('products.name')" prop="Name" :required="true">
                        <el-input v-model="selectedObject.Name"  autofocus></el-input> 
                    </el-form-item>
                 </el-col>
                 <el-col :span="12">
                    <el-form-item :label="$t('products.article_number')" prop="ArticleNumber" :required="true">
                        <el-input v-model="selectedObject.ArticleNumber"></el-input>
                    </el-form-item>
                 </el-col>
                 
                 <el-col :span="12">
                    <el-form-item :label="$t('products.image')" prop="Image" :required="true">
                        <el-upload
                          class="upload-demo"
                          :headers="getHeaders()"
                          :multiple="true"
                          :limit="100"
                          :show-file-list="false"
                          :action="getUploadUrl()"
                          :on-success="handleImageUploadSuccess"
                          >
                          <el-button size="small" type="primary">Click to upload</el-button>
                          <div slot="tip" class="el-upload__tip">jpg/png files with a size less than 500kb</div>
                        </el-upload>
                    </el-form-item>
                 </el-col>
                 <el-col :span="12" v-if="selectedObject.Image != '' && selectedObject.Image != 'default.jpg'">
                   
                    <el-form-item label="Preview">
                      <el-image
                        style="width: 100px; height: 100px"
                        :src="imageUrl"
                        fit="fill"></el-image>
                    </el-form-item>
                 </el-col>

                <el-col :span="24">
                    <el-form-item :label="$t('products.description')" prop="Description" :required="true">
                        <el-input type="textarea" v-model="selectedObject.Description"></el-input>
                    </el-form-item>
                 </el-col>
                 <el-col :span="24">
                    <el-form-item :label="$t('products.category')" prop="IdCategory" :required="true">
                        <el-select v-model="selectedObject.IdCategory" filterable class="full-width">
                            <el-option v-for="item in categories" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
                        </el-select>
                    </el-form-item>
                 </el-col>
             </el-row>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="showPopup=false">{{ $t("cancel") }}</el-button>
            <el-button type="primary" @click="save">{{ $t("confirm") }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
/* eslint-disable prettier/prettier */
import settings from "./../../backend/LocalSettings";
import LocalSettings from './../../backend/LocalSettings';

export default {
  name: "product-dialog",
  data () {
    return { 
      loading: false,
      showPopup: false,
      mode: 'add',
      selectedObject: {},
      categories: [],
      request_new_mode: 0,
      imageUrl: "",
      rules: {
          Name: [ { required: true, message: this.$t('products.required_name') } ],
          ArticleNumber: [ { required: true, message: this.$t('products.required_article_number')  } ],
          Description: [ { required: true, message: this.$t('products.required_description') } ],
          IdCategory: [ { required: true, message: this.$t('products.required_category')  } ],
      }
    }
  },
  methods: {
      getUploadUrl(){
        return LocalSettings.base_url + "/api/index.php/products/upload_image";
      },
      getHeaders(){
        var token =LocalSettings.get_token();
        var ret = { Token: token };
        return ret;
      },
     show_me: function( selectedObject, request_new_mode = 0 ) {
        this.mode = "edit";
        if( selectedObject == null ) {
            selectedObject = { OldProductPrice: 10 };
            this.mode = "add";
        }
        if( this.mode == "edit" ){
          this.imageUrl = LocalSettings.base_url + "/api/assets/products/" + selectedObject.Image;
        }
        this.request_new_mode = request_new_mode;
        this.showPopup        = true;
        this.selectedObject   = JSON.parse( JSON.stringify( selectedObject ) );
    },
    handleImageUploadSuccess(res,file){
      this.imageUrl = res.Url;
      this.selectedObject.Image = res.FileName;
    },
    load_info: function(){
        this.loading = true;
        this.$http
          .post('products/get_info',  {  } )
          .then(function (response) {
            this.loading = false;
            if( settings.verify_response(response, this.$rights)) {
              this.categories = response.body.Categories;
            } else {
              this.$router.push("/");
            }
          });
    },
    save: function() {
        this.$refs['my-form'].validate((valid) => {
          if (valid) {
            this.loading = true;
            this.$http
            .post('products/save',  { mode: this.mode, object: this.selectedObject, request_new_mode: this.request_new_mode } )
            .then(function (response) {
                this.loading = false;
                if( settings.verify_response(response, this.$rights)) {
                this.showPopup = false;
                this.$emit("save");
                } else {
                this.$router.push("/");
                }
            });
          }
        });
    }
  },
  mounted: function() {
      this.load_info();
  }
};
</script>

<style lang="less" scoped>
    .full-width {
        width: 100%;
    }
    .avatar-uploader .el-upload{
        border: 1px solid gray;
    }

    
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 100%;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
    
</style>